<template>
    <div class="pages" :class="{ Mobiles: $store.state.isMobile !== 2 }">
        <!-- <Mobileheader name="产品与方案" routeNmae="/solutioNav"  v-if="$store.state.isMobile !== 3"/> -->
        <div v-if="$store.state.editStatus !== 0">
            <div style="left:15vw;top:15vh;position: absolute;" v-if="isBanner">
                <span style="font-size: 86px;font-weight: bold;">{{ tempName[2] }}</span><br /><br />
                <button @click="dialogVisible = true"
                    style="color: white;font-size:26px;background-color:#3564f2 ;border-radius: 60px;border: none;width: 150px;height: 60px;cursor: pointer;">申请试用</button>
            </div>
            <img style="width: 100%;height:50vh;display: block;" src="@/assets/img/cpfaheader.png" v-if="isBanner" alt="">
        </div>
        <!-- <div v-if="isBanner" class="boxS">
            <div v-for="(item, index) in tempName" style="margin-left: 10px;" :key="index">
                <span style="line-height: 60px;">{{ item }}</span>
                <img v-if="index != tempName.length - 1" src="@/assets/img/icon/urlright.png" alt=""
                    style="display: inline-block;margin: 0 10px;" />
            </div>
        </div>
        <div v-else class="boxS1">
            <div v-for="(item, index) in tempName" style="margin-left: 10px;" :key="index">
                <span style="line-height: 60px;">{{ item }}</span>
                <img v-if="index != tempName.length - 1" src="@/assets/img/icon/urlright.png" alt=""
                    style="display: inline-block;margin: 0 10px;" />
            </div>
        </div> -->
        <!-- 展示图片 -->
        <div v-if="isImg.length > 0 && !isBanner">
            <img style="width:100% ;" v-for="i in isImg" :src="i" alt="">
        </div>
        <div v-else-if="isImg.length > 0 && isBanner">
            <img style="width:100% ;margin-top: 0px;" v-for="i in isImg" :src="i" alt="">
        </div>

        <pdf ref="pdf" v-for="n in numPages" :key="n" :src="pdfUrl" :page="n" style="position:relative ;"></pdf>
        <div class="more" v-if="httpUrl">
            <img class="gifmore" src="@/assets/img/lookMore.gif" alt="" @click="onHttpUrl">
        </div>
        <div>
            <CopyRight v-if="!$route.query.isApplet"></CopyRight>
        </div>


        <el-dialog title="产品申请试用" :visible.sync="dialogVisible" width="30%">
            <el-form :model="ruleForm" :rules="rules" ref="addForm" label-width="130px" class="demo-ruleForm">
                <el-form-item label="产品名称：">
                    <span style="font-weight: bold; color: #333;">{{ ruleForm.product }}</span>
                </el-form-item>
                <el-form-item label="联系人：" prop="name">
                    <el-input v-model="ruleForm.name" :maxLength="11" style="width: 95%"></el-input>
                </el-form-item>
                <el-form-item label="联系手机：" prop="phone">
                    <el-input v-model="ruleForm.phone" style="width: 95%"></el-input>
                </el-form-item>
                <el-form-item label="单位名称：" prop="company">
                    <el-input v-model="ruleForm.company" style="width: 95%"></el-input>
                </el-form-item>
                <el-form-item label="职务：" prop="duties">
                    <el-input v-model="ruleForm.duties" style="width: 95%"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('addForm')">提交申请</el-button>
                    <el-button @click="dialogVisible = false">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>
  
<script>
// isApplet 1是小程序跳转的
import vuePdf from "vue-pdf";
import { addProductUse } from "@/api/solutio.js"
import { getProductProgrammeList, getProductUseList, followUp } from "../../api/solutio";
const pdf = { ...vuePdf, destroyed: undefined }

export default {
    components: {
        pdf
    },


    data() {
        return {
            pdfUrl: "",
            numPages: undefined,
            httpUrl: "",
            type: 1,
            dialogVisible: false,

            ruleForm: {},
            rules: {
                name: [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                    { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入联系人电话', trigger: 'blur' },
                    { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入联系人单位名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                duties: [
                    { required: true, message: '请输入你的职务', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ],

            },
            productName: "",
            tableData: [],
            isTwin: '',     //是否是数字孪生栏
            navigation: null,   //导航栏标题
            listData: [],
            tempName: [],
            tempParentId: '',
            isId: [],   //dev与pro环境id判断
            isImg: [], //四张图片
            isBanner: false,   //是否显示banner
        }
    },
    watch: {
        'isBanner': function (newValue, oldValue) {
            this.isBanner = newValue
        }
    },
    mounted() {
        this.numPages = undefined;
        this.type = this.$route.query.type;
        this.ruleForm.product = this.$route.query.productName;
        this.isTwin = this.$route.query.parentId
        this.navigation = this.$route.query.objId
        //出来上级页面传过来的四张图片
        if (!this.$route.query.name.endsWith('.pdf')) {
            this.isImg = this.$route.query.name.split(',')


        }
        this.getList()
        this.openPage()



    },
    methods: {
        getList() {
            getProductProgrammeList({ isRelease: this.$store.state.editStatus }).then(res => {
                this.listData = res.data;
                console.log(this.navigation,this.listData, 'datae')
                let result = this.findObjectById(this.navigation, this.listData);
                this.tempName = [...new Set(this.tempName)];  //数组去重
                this.isBanner = this.tempName.map(item => item.startsWith('数字孪生'))   //判断每一项是否包含数字孪生
                let hasTrue = this.isBanner.some(item => item === true);                //如果有一项为true就为true
                if (hasTrue) {
                    this.isBanner = true
                } else {
                    this.isBanner = false
                }
                console.log(this.tempName, 'name')
                this.tempName.reverse();    //倒叙
                this.tempName.unshift('产品与方案'); // 在数组开头添加一个值
                this.isId = [...new Set(this.isId)];  //数组去重
            })
        },
        // 递归查找父节点id
        findObjectById(id, data) {
            for (let item of data) {
                if (item.id === id) {
                    return item;
                }
                if (item.childrenList) {
                    let result = this.findObjectById(id, item.childrenList);
                    if (result) {
                        this.tempName.push(result.name)
                        this.isId.push(result.id)
                        this.tempParentId = result.parentId
                        if (result.parentId != '0') {
                            let resultFindId = this.findObjectById(result.parentId, this.listData);
                            if (resultFindId) {
                                this.tempName.push(resultFindId.name)
                                this.isId.push(result.id)
                                return resultFindId
                            }
                        }
                        return result;
                    }
                }
            }
            return null;
        },
        openPage() {
            let name = this.$route.query.name;
            this.httpUrl = this.$route.query.url
            let url = this.$route.query.name;
            url = url.replace('https://www.dpark.com.cn', 'https://www.dpark.com.cn')
            var loadingTask = pdf.createLoadingTask(url);
            this.pdfUrl = loadingTask;
            console.log('name:', url)
            if (this.pdfUrl) {
                this.pdfUrl.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                    console.log(this.numPages, pdf.numPages)
                }).catch(err => {
                    console.log('err', err)
                });
            }
        },
        onHttpUrl() {
            window.open(this.httpUrl, '_blank')
        },

        submitForm(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid) {
                    addProductUse(this.ruleForm).then(res => {
                        this.$message.success('提交成功');
                        this.dialogVisible = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    }
}
</script>
  
<style lang="scss" scoped>
.pages {
    position: relative;
    margin-top: 50px;
    .boxS {
        height: 60px;
        width: 100%;
        background-color: #edefff;
        display: flex;
        justify-content: flex-start;
        z-index: 5;
    }

    .boxS1 {
        height: 60px;
        width: 100%;
        background-color: #edeff6;
        margin-top: 60px;
        display: flex;
        justify-content: flex-start;
        z-index: 5;
    }

    .bannerImg {
        width: 100%;
        display: block;
    }

    .more {
        position: absolute;
        top: 10px;
        right: 10px;

        .gifmore {
            width: 100px;
        }
    }
}

.onTrials {
    position: fixed;
    bottom: 110px;
    width: 182px;
    height: 100px;
    right: 0;
    cursor: pointer;
}
</style>